export default __webpack_public_path__ + "static/media/26.02274976.jpg";